module.exports = __webpack_public_path__ + "img/m2@2x.d2d1cb0b.png";